<template>
  <div class="px-4 text-center tracking-wider py-5 bgLiveMainBlack flex justify-center items-center">
    <!-- <router-link :to="{ name: 'service', params: { id: 'flash' }}" class="block text-sm text-NotoSansLight text-white hover:underline">【重要公告】因應政府防疫措施，總公司門市即日起暫停開放購買，造成不便請見諒。
    </router-link> -->
    <a class="block text-base text-NotoSansLight text-white tracking-wider">【重要公告】適逢年度盤點，12/19（二）晚上9:00後付款成功之訂單，將延後至2024/1/2（二）起依訂單順序陸續出貨。</a>
    <a class="px-2 md:px-3 lg:px-4 xl:px-6 cursor-pointer flex items-center" title="關閉通知"
      @click="setCookie">
      <font-awesome-icon icon="times-circle" class="times-circle text-white text-2xl hover:text-gray-300" />
    </a>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'IndexNotice',
  data () {
    return {
      // 下架時間
      disableDay: '2024/01/02'
    }
  },
  props: {
  },
  beforeMount () {
  },
  mounted () {
    this.getCookie()
  },
  watch: {
  },
  methods: {
    disableDayFunc () {
      // 設置下架時間判斷
      let self = this
      let curDate = new Date()
      let curTamp = curDate.getTime()
      let expire = new Date(self.disableDay).getTime()
      expire < curTamp ? self.$store.dispatch('isIndexTopNotice', false) : null
    },
    async getCookie () {
      // 檢查今天不再顯示
      let self = this
      await self.disableDayFunc()
      if (self.$store.state.isIndexTopNotice && self.$cookie.get('expireCookie')) {
        self.$store.dispatch('isIndexTopNotice', false)
        self.$store.dispatch('isIndexTopMainBody', true)
      }
    },
    setCookie () {
      // 設置不再顯示
      let self = this
      self.$cookie.set('expireCookie', '1D', { expires: '1D' })
      self.$store.dispatch('isIndexTopNotice', false)
      self.$store.dispatch('isIndexTopMainBody', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .temporarily-notice {
    background-color: #828282;
  }
  .circle, .times-circle {
    transition: .2s;
  }
  .controls-item {
    input[type="checkbox"] {
      box-sizing: border-box;
      padding: 0;
      margin-right: .4em;
      width: 100%;
      margin-bottom: 10px;
      &:hover + label:before {
        background: #e6e6e6;
      }
    }
    label {
      position: relative;
      display: inline-block;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      vertical-align: middle;
    }
    span {
      line-height: 18px;
    }
  }
</style>
